import script from "./LKProjectCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LKProjectCard.vue?vue&type=script&setup=true&lang=js"

import "./LKProjectCard.vue?vue&type=style&index=0&id=76ce2fc3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ce2fc3"]])

export default __exports__